// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"RecurrenceCancellation--checkboxContainer--002f6d"};